var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxtop"},[_c('i'),_c('span',[_vm._v(_vm._s(_vm.calsstop.title))]),[_c('div',{staticClass:"any"},[_vm._t("default")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }